module.exports = __webpack_public_path__ + "static/media/lahore-dha.555cc357.svg";